<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="formData.name"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="surname" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="formData.surname"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('middle_name')">
                        <b-form-input v-model="formData.middle_name"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="passport_number" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('passport_number')">
                            <b-form-input v-model="formData.passport_number"
                                          :class="errors[0] ? 'is-invalid':''"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="passport_country_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('passport_country')">
                            <country-selectbox v-model="formData.passport_country_id"
                                               :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="4">
                    <ValidationProvider name="gender" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('gender')">
                            <gender-selectbox v-model="formData.gender" :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="birthdate" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('date_of_birth')" class="position-relative">
                            <select-date v-model="formData.birthdate"></select-date>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="birthplace" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('birthplace')">
                            <b-form-input v-model="formData.birthplace"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col md="4" cols="12">
                    <ValidationProvider name="nationality_code" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('nationality')">
                            <country-selectbox v-model="formData.nationality_code"
                                               :validateError="errors[0]"
                                               valueType="code"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="race" v-slot="{valid, errors}">
                        <b-form-group>
                            <label>{{ $t('race') }}</label>
                            <parameter-selectbox
                                code="races"
                                v-model="formData.race"
                                :validateError="errors[0]">

                            </parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
<!--                <b-col cols="12" md="4">
                    <ValidationProvider name="visa_type" v-slot="{valid, errors}">
                        <b-form-group>
                            <label>Visa Type</label>
                            <parameter-selectbox
                                code="visa_types"
                                v-model="formData.visa_type"
                                :validateError="errors[0]">

                            </parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>-->
                <b-col cols="12" md="4">
                    <ValidationProvider name="ssn" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('ssn')">
                            <b-form-input
                                v-model="formData.ssn"
                                v-mask="'###-##-####'"
                                placeholder="XXX-XX-XXXX"
                                :class="errors[0] ? 'is-invalid' : ''"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col v-if="!isTeflProgram && !isCeProgram" cols="12" md="4">
                    <ValidationProvider name="sevis_id" :rules="(!isTeflProgram && !isCeProgram) ? 'required' : ''" v-slot="{valid, errors}">
                        <b-form-group :label="$t('SEVIS ID')">
                            <b-form-input v-model="formData.sevis_id"
                                          :class="errors[0] ? 'is-invalid':''"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox";
import GenderSelectbox from "@/components/interactive-fields/GenderSelectbox";

// Services
import StudentProgramService from "@/services/StudentProgramService"
import ConstantService from "@/services/ConstantService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
import moment from "moment";

export default {
    components: {
        CountrySelectbox,
        GenderSelectbox,

        ValidationProvider,
        ValidationObserver
    },
    props: {
        studentProgram: {
            type: Object,
            default: null,
        }
    },
    created() {
        this.formId = this.studentProgram.id;
        this.formData = {
            passport_number: this.studentProgram.passport_number,
            passport_country_id: this.studentProgram.passport_country_id,
            name: this.studentProgram.name,
            surname: this.studentProgram.surname,
            gender: this.studentProgram.gender,
            race: this.studentProgram.race,

            father_name: this.studentProgram.father_name,
            mother_name: this.studentProgram.mother_name,
            birthdate: this.studentProgram.birthdate,
            birthplace: this.studentProgram.birthplace,
            ssn: this.studentProgram.ssn,
            middle_name: this.studentProgram.middle_name,

            nationality_code: this.studentProgram.nationality_code,
            sevis_id: this.studentProgram.sevis_id,
        }
    },
    data() {
        return {
            formId: null,
            formData: {},
            formProcess: false,
        }
    },
    computed: {
        isTeflProgram() {
            return this.studentProgram?.program_code === '0702006';
        },
        isCeProgram() {
            return this.studentProgram?.program_code === '0702005';
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                let formData = {
                    ...this.formData
                }

                if (this.isTeflProgram || this.isCeProgram) {
                    delete formData.sevis_id;
                }

                formData.birthdate = formData.birthdate ? moment(formData.birthdate).format('MM/DD/YYYY') : null

                this.formProcess = true
                StudentProgramService.updateIdentity(this.formId, formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    })
                    .finally(() => {
                        this.formProcess = false
                    })
            }
        }
    }
}
</script>

